<script>
import { pageMarronniersProps, usePageMarronniers } from "./mixin";
import Breadcrumbs from "@/components/molecules/breadcrumbs/mobile";
import ChildrenCategories from "@/components/organisms/product-list/product-list-header/children-categories";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import ProductListItemGrid from "@/components/organisms/product-list/product-list-item-grid/mobile";
import Container from "@/components/atoms/container";
import PushProductsBlock from "@/components/organisms/push-products-block/mobile";
import Card from "@/components/molecules/card";
import TitleImage from "@/components/molecules/title-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";

export default {
  name: "PageMarronniers",
  components: {
    Breadcrumbs,
    ChildrenCategories,
    HtmlParser,
    Container,
    PushProductsBlock,
    Card,
    TitleImage,
    ListItem,
    List
  },
  props: {
    ...pageMarronniersProps()
  },
  setup(props) {
    const {
      pageMarronnierCodes,
      limitMaxRayon,
      title,
      description,
      breadcrumbs,
      childrenCategories,
      attributes,
      isNational,
      breadcrumb,
      pushDataBanniereMea,
      marronniersMerchProduit,
      getPushData,
      getPushTitle
    } = usePageMarronniers(props);

    return {
      pageMarronnierCodes,
      limitMaxRayon,
      title,
      description,
      breadcrumbs,
      childrenCategories,
      attributes,
      isNational,
      breadcrumb,
      pushDataBanniereMea,
      marronniersMerchProduit,
      getPushData,
      getPushTitle
    };
  },
  data() {
    return {
      ProductListItemGrid
    };
  }
};
</script>
<template>
  <div class="u-bgcolor-white u-pb-md">
    <Container>
      <Breadcrumbs
        class="u-mr-sm u-ml-sm"
        :breadcrumbs="breadcrumb"
        :divider="false"
      />
      <div class="u-p-sm">
        <h1
          v-if="title"
          class="u-font-28 u-font-secondary u-font-700 u-block"
        >
          {{ title }}
        </h1>
        <HtmlParser
          v-if="description"
          class="u-color-text-light u-font-14 u-mb-sm"
          context="MARRONNIER DESCRIPTION"
          :content="description"
        />
        <ChildrenCategories
          v-if="childrenCategories"
          class="u-mb-sm"
          :children-categories="childrenCategories"
        />
        <HtmlParser
          v-if="attributes.description_longue"
          class="u-mb-md"
          context="MARRONNIER DESCRIPTION LONGUE"
          :content="attributes.description_longue"
        />
      </div>
    </Container>

    <div
      v-if="marronniersMerchProduit && marronniersMerchProduit.products && marronniersMerchProduit.products.length > 0"
      class="u-bgcolor-bg u-p-md u-pb-xlg"
    >
      <Card class="u-pt-sm u-pb-sm">
        <h2 class="u-font-secondary u-color-primary u-font-32 -font-700 u-text-center u-mt-lg u-mb-md u-pl-sm u-pr-sm">
          {{ marronniersMerchProduit.titre }}
        </h2>

        <PushProductsBlock
          :label="trackingCodes.LABELGA.PageMarroniers"
          :products="marronniersMerchProduit.products"
          product-separator
          :is-national="isNational"
        />
      </Card>
    </div>

    <Container v-if="getPushData(pageMarronnierCodes.MARRONNIER_RAYONS)">
      <div>
        <h2
          v-if="getPushTitle(pageMarronnierCodes.MARRONNIER_RAYONS)"
          class="u-font-700  u-mt-lg20 u-mb-md"
        >
          {{ getPushTitle(pageMarronnierCodes.MARRONNIER_RAYONS) }}
        </h2>
      </div>
      <List class="u-flex u-flex-wrap">
        <ListItem
          v-for="i in limitMaxRayon"
          :key="i"
        >
          <TitleImage
            v-if="getPushData(pageMarronnierCodes.MARRONNIER_RAYONS, i).id"
            :key="i"
            :image-path="getPushData(pageMarronnierCodes.MARRONNIER_RAYONS, i).image"
            :image-alt="getPushData(pageMarronnierCodes.MARRONNIER_RAYONS, i).titre_action"
            class="c-header-menu-layer__title-image"
            :dimension="200"
            :slug="getPushData(pageMarronnierCodes.MARRONNIER_RAYONS, i).lien_cta"
          >
            {{ getPushData(pageMarronnierCodes.MARRONNIER_RAYONS, i).front_label }}
          </TitleImage>
        </ListItem>
      </List>
    </Container>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/product-list-header.scss";
</style>
